import { Modal } from 'src/components/baseComponents';
import { Button as AntButton } from 'antd';
import { InfoCircleIcon } from 'src/icons';
import { CommonFormProps } from '.';
import { analytics } from 'src/services/analytics';
import { getAppointmentDetailsForAnalytics } from 'src/utils';

type Props = CommonFormProps;

export const TOCNeuro = ({
  isOpen,
  appointment,
  form,
  onSave,
  loading,
}: Props) => {
  const initialValues = {};
  const formContent = form.content as { title: string; s3_url: string };

  const handleClick = async () => {
    analytics.track(
      'Clicked Continue In TOC Neuro Form',
      getAppointmentDetailsForAnalytics(appointment!)
    );
    await onSave({
      form_type: 'TOC_Neuro',
      response: {},
    });
  };

  return (
    <div>
      {/** @ts-ignore */}
      <Modal
        open={isOpen}
        closable={false}
        className={'toc-modal'}
        formClassName={'grid grid-cols-2 gap-8'}
        initialValues={initialValues}
        onSubmitLoading={loading}
        disableSubmit={loading}
        submitButtonText=""
        cancelButtonText=""
        centered={true}
        customBody={
          <div>
            <div className="dob-text p-4">
              <div
                className="flex text-center text-[18px] font-medium text-[#000]"
                style={{ fontFamily: 'Poppins' }}
              >
                {/** @ts-ignore */}
                <InfoCircleIcon className={`mr-1`} />
                <span className="mx-1">Note</span>
              </div>
              <div
                className="text-justify mt-2 ml-9"
                style={{ fontFamily: 'Poppins' }}
              >
                {formContent?.title}
              </div>
            </div>
            <div style={{ textAlign: 'center' }} className="mx-2 lg:mx-40 my-5">
              <img
                src={formContent?.s3_url}
                alt="TOC image"
                className="shadow-2xl p-2 rounded-xl"
              />
            </div>
            <div className="text-center">
              <AntButton
                className="modal__form-footer__submit-button"
                onClick={handleClick}
              >
                Continue
              </AntButton>
            </div>
          </div>
        }
      />
    </div>
  );
};
